import { render, staticRenderFns } from "./match2024p.vue?vue&type=template&id=4db71456"
import script from "./match2024p.vue?vue&type=script&lang=js"
export * from "./match2024p.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports